module.exports = __webpack_public_path__ + "img/Biker.9eda47e7.jpg";